import type { Address } from '@uroute/shared';
import { mapsUrl, telUrl } from '../lib/format';
import { ArrowUp, Navigation, Phone } from './icons';

export interface AddressBlockProps {
  kind: 'collection' | 'delivery';
  address: Address;
}

/** Tap-to-call and tap-to-navigate address card. */
export function AddressBlock({ kind, address }: AddressBlockProps) {
  const phone = address.contactPhone?.trim();
  const name = address.contactName?.trim();

  return (
    <section className="addr" data-testid={`address-${kind}`}>
      <header className="addr__head">
        <span className="addr__icon" aria-hidden="true">
          {kind === 'collection' ? <ArrowUp size={16} /> : <Navigation size={16} />}
        </span>
        <span className="label-caps">{kind === 'collection' ? 'Collection point' : 'Delivery address'}</span>
      </header>

      <address className="addr__body">
        <strong className="addr__line1">{address.line1}</strong>
        {address.line2 ? <span>{address.line2}</span> : null}
        <span>
          {address.city} <span className="u-data">{address.postcode}</span>
        </span>
        <span className="muted">{address.country}</span>
        {name ? <span className="addr__contact">Attn: {name}</span> : null}
      </address>

      <div className="addr__actions">
        {phone ? (
          <a
            className="u-btn u-btn--secondary addr__btn"
            href={telUrl(phone)}
            data-testid={`call-${kind}`}
            aria-label={`Call ${name ?? (kind === 'collection' ? 'collection point' : 'recipient')} on ${phone}`}
          >
            <Phone size={16} />
            Call
          </a>
        ) : null}
        <a
          className="u-btn u-btn--primary addr__btn"
          href={mapsUrl(address)}
          target="_blank"
          rel="noreferrer"
          data-testid={`navigate-${kind}`}
          aria-label={`Navigate to ${address.line1}, ${address.postcode}`}
        >
          <Navigation size={16} />
          Navigate
        </a>
      </div>
    </section>
  );
}
